import React, { useRef, useState } from "react";
import { ImageBuilder, getImgUrl } from "./image-builder";
import { cn } from "../../lib/helpers";

const ZOOM_SIZE = "180%";

export const ImageMagnifier = ({ image, width, className }) => {
  const [isHovering, setIsHovering] = useState(false);
  const lensRef = useRef(null);

  const handleEnter = () => {
    if (lensRef.current && !lensRef.current.style.backgroundImage) {
      lensRef.current.style.backgroundImage = `url(${getImgUrl({ image })})`;
      lensRef.current.style.backgroundSize = ZOOM_SIZE;
      lensRef.current.style.backgroundRepeat = "no-repeat";
    }
    setIsHovering(true);
  };

  const handleMove = (e) => {
    if (!lensRef.current) return;
    const rect = e.currentTarget.getBoundingClientRect();
    const xPct = Math.min(100, Math.max(0, ((e.clientX - rect.left) / rect.width) * 100));
    const yPct = Math.min(100, Math.max(0, ((e.clientY - rect.top) / rect.height) * 100));
    lensRef.current.style.backgroundPosition = `${xPct}% ${yPct}%`;
  };

  return (
    <div
      className={cn("relative overflow-hidden cursor-[zoom-in]", className)}
      onMouseEnter={handleEnter}
      onMouseMove={handleMove}
      onMouseLeave={() => setIsHovering(false)}
    >
      <ImageBuilder image={image} width={width} className={className} />
      <div
        ref={lensRef}
        className={cn(
          "absolute inset-0 transition-opacity duration-200",
          isHovering ? "opacity-100" : "opacity-0"
        )}
      />
    </div>
  );
};
